import * as React from "react";
import { HeaderView } from "./views/header/HeaderView";
import { useRouter } from "../context/Router";
export var Header = function () {
    var navigate = useRouter().navigate;
    return React.createElement(HeaderView, { navigate: navigate });
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Header.tsx
// module id = 19
// module chunks = 1